// https://github.com/yujinjin/mobile-message
import MobileMessage from 'mobile-message'
import 'mobile-message/dist/message.css'
let Message = MobileMessage.get({});

// info , success , warning , error , alert , confirm , multiple , vertical , bottomSheet , prompt
export const msgAlert = {
  info: function(msg) {
    Message.info(msg);
  },
  error: function(msg) {
    Message.error(msg);
  },
  success: function(msg) {
    Message.success(msg);
  },
  warning: function(msg) {
    Message.warning(msg);
  }
}



// WEBPACK FOOTER //
// ./src/utils/message.js